import { Modal } from 'antd';
import { memo, useState } from 'react';

import PlanInfo from '@/components/PlatformSubscription/Modals/SubscriptionModal/planInfo';

import { IPlan } from '../../../../utils/interfaces/Subscription';

interface Props {
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  plan?: IPlan;
}
const SubscriptionModal: React.FC<Props> = ({ open, setOpen, plan }) => {
  const [subscriptionSuccess, setSubscriptionSuccess] = useState(false);

  return (
    <Modal
      maskClosable={false}
      title={null}
      closable={false}
      open={open}
      onCancel={() => {
        setOpen(false);
        setSubscriptionSuccess(false);
      }}
      centered
      footer={null}
      className='m-0'
      classNames={{
        content: 'p-0 rounded-2xl md:w-[500px] w-full',
        wrapper: 'md:text-center text-start',
        body: 'md:w-auto w-dvw',
      }}
    >
      <PlanInfo
        subscriptionSuccess={subscriptionSuccess}
        setOpen={setOpen}
        setSubscriptionSuccess={setSubscriptionSuccess}
        plan={plan}
      />
    </Modal>
  );
};

export default memo(SubscriptionModal);
